<template>
  <div class="am-attachment">
    <div class="am-border-div">
      <div class="am-attachment-header am-main-top-box">
        <div class="am-attachment-title am-main-top-box-title">{{ header }}</div>
        <div class="am-attachment-icons">
          <a :title="title" @click="toggleAttachment"><svg-icon icon="back" title="back" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
          </a>
        </div>
      </div>
    <div class="am-card-body">
      <div class="top-space"></div>
      <div class="am-attachment">
        <div class="am-attachment-browse-content">
          <fieldset>
            <legend>Add Attachment</legend>
            <form method="POST" class="am-attachment-form" name="attachmentForm">
              <div class="am-attachment-browse-section input-group input-group-xs row">
                <file-upload
                        ref="upload"
                        :drop="true"
                        :multiple="true"
                        v-model="files"
                        @input-file="inputFile"
                        @input-filter="inputFilter"
                        :post-action="postURL"
                        class="am-file-upload"
                        :headers="{Authorization: 'Bearer ' +  authToken}"
                >
                  <span class="input-group-btn col-1">
                    <button class="btn btn-primary btn-xs" @click.prevent="$refs.upload.active = true" type="button">Browse</button>
                  </span>
                  <div class="am-attachment-file-drop form-control input-xs progress col-11">
                    <span>Or drop files here...</span>
                  </div>
                </file-upload>
              </div>
              <div v-for="(file, index) in files" class="row" :key="file.name">
                <div class="am-attachment-image-hover col-xs-4">
                  <label>File Name: </label>
                  <a class="am-attachment-file-name" href="#">{{file.name}}
                    <span v-if="['PNG', 'JPEG', 'JPG', 'GIF'].includes(getExtension(file.name))">
                      <img :alt=file.name :src=file.blob>
                    </span>
                  </a>
                </div>
                <div class="col-xs-4">
                  <label>Description: </label>
                  <input type="text" class="am-attachment-file-description" v-model="file.data.description">
                  <input type="button" value="Remove" @click="remove(index)" class="btn btn-warning btn-xs">
                </div>
              </div>
            </form>
          </fieldset>
        </div>
        <div class="am-attachment-table">
          <table class="am-attachment-table-results">
            <thead>
            <tr>
              <th class="center">V</th>
              <th class="center">D</th>
              <th>File Name</th>
              <th>Description</th>
              <th>Added By</th>
              <th>Date</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="attachment in attachments" :key="attachment.id">
              <td><a title="View Attachment" target="_blank" :href="getFilePath(attachment.id)"><svg-icon class="am-glyphicon-medium am-glyphicon-blue" icon="view" title="View Attachment"></svg-icon></a></td>
              <td><a title="Delete Attachment" @click="deactivate(attachment.id)"><svg-icon class="am-glyphicon-medium am-glyphicon-blue" icon="delete" title="Delete Attachment"></svg-icon></a></td>
              <td>{{attachment.filename}}</td>
              <td>{{attachment.description}}</td>
              <td>{{attachment.creator ? attachment.creator.name : ''}}</td>
              <td>{{attachment.uploadedDate}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
      <div class="am-attachment-ribbon-bottom am-main-bottom-box">
        <button v-if="hasAttachmentType" class="am-attachment-button" @click.prevent="$refs.upload.active = true">
          <img src="@/assets/save.png">
        </button>
        <button v-if="!hasAttachmentType" class="am-attachment-button" @click="showErrorMessage()">
          <img src="@/assets/save.png">
        </button>
      </div>
      <modal name="MessagePopup" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3"  :adaptive="true" width="370px" height="auto">
        <message-popup :confirmDelete="false" :errors="errorMessageString" messageHeader="Error" :isError="true"></message-popup>
      </modal>
    </div>
  </div>
</template>

<script>
import api from './../http'
import VueUploadComponent from 'vue-upload-component'
import config from '@/config/global.config'
import MessagePopup from "./MessagePopup";
export default {
  name: 'Attachment',
  data: function () {
    return {
      files: [],
      postURL: config.apiUrl('api/v1/attachment/uploaded-images/' + this.id + '/' + this.tableName + '/' + this.attachmentType + '/' + this.customerId + '/upload'),
      authToken: this.$store.state.auth.token,
      description: [],
      upload: false,
      title: 'Back to ' + this.header.toLowerCase() + ' list',
      hasAttachmentType: false,
      errorMessageString: 'To add an attachment you must setup an attachment type'
    }
  },

  props: {
    id: { //  pkId
      type: Number,
      required: true
    },
    header: {
      type: String,
      required: true
    },
    tableName: {
      type: String,
      required: true
    },
    customerId: {
      type: Number,
      required: true
    },
    attachmentType: {
      type: String,
      required: true
    }
  },

  asyncComputed: {
    attachments () {
      return api.makeRequest('/api/v1/attachment/uploaded-images/' + this.id + '/' + this.tableName + '/list').then(
        (data) => {
          return data.data.results
        }
      )
    }
  },
  components: {
    MessagePopup,
    VueUploadComponent
  },

  computed: {
    descriptionJSON () {
      return JSON.stringify(this.description)
    }
  },

  methods: {
    /**
             * Has changed
             * @param  Object|undefined   newFile   Read only
             * @param  Object|undefined   oldFile   Read only
             * @return undefined
             */
    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log('response', newFile.response)
        if (newFile.xhr) {
          //  Get the response status code
          console.log('status', newFile.xhr.status)
        }
      }
    },
    /**
             * Pretreatment
             * @param  Object|undefined   newFile   Read and write
             * @param  Object|undefined   oldFile   Read only
             * @param  Function           prevent   Prevent changing
             * @return undefined
             */
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|gif|png|webp|pdf|doc|docx|xls|xlsx|txt)$/i.test(newFile.name)) {
          return prevent()
        }
      }

      // Create a blob field
      newFile.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file)
      }
    },

    addText () {
      let file = new window.File(['foo'], 'foo.txt', {
        type: 'text/plain'
      })
      this.$refs.upload.add(file)
    },
    remove (index) {
      this.$delete(this.files, index)
    },

    toggleAttachment: function () {
      this.$emit('toggleAttachment')
    },

    getExtension: function (fileName) {
      let len = fileName.length
      let begin = fileName.indexOf('.') + 1
      return fileName.substring(begin, len).toUpperCase()
    },

    getDescription () {
      return this.description
    },

    refreshList: function () {
      this.$asyncComputed.attachments.update()
    },

    deactivate (id) {
      let self = this
      api.putRequest('/api/v1/attachment/uploaded-images/' + id + '/deactivate').then(function (response) {
        console.log(response)
        self.refreshList()
      })
    },
    getFilePath(id) {
      return config.apiUrl('/api/v1/attachment/uploaded-images/' + id + '/download')
    },
    showErrorMessage () {
      this.$modal.show('MessagePopup')
    }

  },

  mounted () {
    let self = this
    api.makeRequest('/api/v1/attachment/uploaded-images/' + self.attachmentType + '/attachmentType').then(function (response) {
      self.hasAttachmentType = response.data.results !== null
    })
    this.$watch(
      () => {
        return this.$refs.upload.uploaded
      },
      (val) => {
        if (val === true) {
          self.refreshList()
          self.$refs.upload.clear()
        }
      }
    )
  },
  watch: {
    'files': {
      handler: function () {
        let self = this

        this.files.forEach(file => {
          file.data.user = self.$store.state.auth.user.id
        })
      },
      deep: true
    }
  }
}
</script>

<style scoped>
    .am-attachment{
        padding: 15px;
    }

    .center{
        width: 24px;
        height: 24px;
    }

    fieldset{
        border: 2px groove threedface;
    }

    legend{
        padding: 0 6px 4px;
        color: #2777a3;
        font-weight: 700;
        font-family: Verdana;
        font-size: 11px;
    }

    .am-attachment-file-drop{
        border-radius: 0 3px 3px 0;
        position: relative;
        border-left: 0;
        margin: 0;
        background-color: #f5f5f5;
        font-size: 12px;
    }

    .am-attachment-file-name{
        text-align: left;
    }

    .am-attachment-browse-section{
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 5px;
    }

    .am-attachment-table-results {
        width: 1130px;
        margin-top: 20px;
    }

    .am-attachment-table-results tbody tr:nth-child(odd) {
        background-color: #ECECEC;
    }

    .am-attachment-table-results tbody tr:nth-child(even) {
        background-color: #F4F4F4;
    }

    .am-attachment-table-results thead {
        background-color: black;
        color: white;
    }

    .am-attachment-table-results td {
        padding: 2px;
        text-align: left;
        font-size: 11px;
    }

    .am-attachment-table-results th {
        padding: 2px;
        font-size: 11px;
    }

    .am-file-upload{
        width: 1050px;
        text-align: left;
    }

    .am-border-div{
        border: 1px solid #8c8c8c;
    }

    .am-attachment-header {
        height: 35px;
    }

    .am-attachment-header a {
        float: right;
        margin-top: 6px;
        margin-right: 5px;
    }

    .am-attachment-icons {
        margin-right: 15px;
        cursor: pointer;
    }

    .am-attachment-title {
        font-size: 14px;
        font-weight: bold;
        float: left;
        margin-left: 25px;
        margin-top: 5px;
    }

    .am-card-body {
        border-top:1px solid #8c8c8c;
        border-bottom:1px solid #8c8c8c;
    }

    .top-space {
        padding: 10px;
    }

    .am-attachment-table tbody tr:nth-child(odd) {
        background-color: #ECECEC;
    }

    .am-attachment-table tbody tr:nth-child(even) {
        background-color: #F4F4F4;
    }

    .am-attachment-table thead {
        background-color: black;
        color: white;
    }

    .am-attachment-table td {
        padding: 2px;
        text-align: left;
        font-size: 11px;
    }

    .am-attachment-table th {
        padding: 2px;
        font-size: 11px;
    }

    .am-attachment-ribbon-bottom {
        height: 35px;
    }

    .task-tooltip span:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .am-attachment-image-hover {
      position:relative;
    }
    .am-attachment-image-hover a span {
      position:absolute;
      display:none;
      z-index:99;
      left:70%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
    }
    .am-attachment-image-hover a:hover span {
      display:block;
    }

    .am-attachment-button{
      background: transparent;
      border: none;
      margin-top: 3.5px;
    }

</style>
